const part = [
    {
        path: 'area-management-list',
        name: 'area-management-list',
        meta: {
            icon: 'md-people',
            title: '区域管理',
            notCache: true,
            access: ['S'],
            items: [
            ]
        },
        component: () => import('@/view/system-management/area-management/area-list')
    }
];

export default part;
